export default class Figure extends Component {
  render() {
    const { children, fullWidth = false, margin = 20 } = this.props

    return (
      <div
        style={{
          display: "grid",
          gridColumn: !fullWidth && "screen",
          width: fullWidth && "100%",
          justifyContent: "center",
          borderTop: `1px solid rgba(0, 0, 0, 0.1)`,
          borderBottom: `1px solid rgba(0, 0, 0, 0.1)`,
          paddingTop: 20,
          paddingBottom: 20,
          marginTop: margin,
          marginBottom: margin,
          justifyContent: "center",
          background: "rgba(246,249,252,1)",
        }}
      >
        {children}
      </div>
    )
  }
}
